import React, { useCallback, useEffect, useState } from 'react'
import { useTheme } from 'styled-components'
import { getButtonTextColor } from 'styles/functions'
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi'

export const usePrevNextButtons = (emblaApi) => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true)

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return
    emblaApi.scrollPrev();
  }, [emblaApi])

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return
    emblaApi.scrollNext();
  }, [emblaApi])

  const onSelect = useCallback((emblaApi) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev())
    setNextBtnDisabled(!emblaApi.canScrollNext())
  }, [])

  useEffect(() => {
    if (!emblaApi) return

    onSelect(emblaApi)
    emblaApi.on('reinit', onSelect).on('select', onSelect)
  }, [emblaApi, onSelect])

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  }
}

export const PrevButton = (props) => {
  const { children, disabled, ...restProps } = props
  const theme = useTheme()

  return (
    <button
      className={'embla__button embla__button--prev'.concat(disabled ? ' embla__button--disabled' : '')}
      type="button"
      {...restProps}
    >
      <FiArrowLeft className={'embla__button__arrow'} style={{ color: theme ? getButtonTextColor(theme) : undefined }} />
      {children}
    </button>
  )
}

export const NextButton = (props) => {
  const { children, disabled, ...restProps } = props
  const theme = useTheme()

  return (
    <button
      className={'embla__button embla__button--next'.concat(disabled ? ' embla__button--disabled' : '')}
      type="button"
      {...restProps}
    >
      <FiArrowRight className={'embla__button__arrow'} style={{ color: theme ? getButtonTextColor(theme) : undefined }} />
      {children}
    </button>
  )
}
